export const TOTAL_MESSAGES_SENT_LIMIT = 10;

export const NAVIGATION_PATHS = {
  home: '/',
  sign_in: 'sign-in',
  sign_up: 'sign-up'
};

export const TOAST_TYPES = {
  danger: 'danger',
  success: 'success',
  warning: 'warning'
};

export const SOUND_TYPES = {
  receive: 'receive',
  sent: 'sent'
};
